import Vue from "vue";
import formKickoff from "./components/form-kickoff.vue";
import store from "./store";
import "./assets/main.scss";
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuelidate from 'vuelidate';
import { email } from "vuelidate/lib/validators";

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(Vuelidate);

// Registrera kickoff-formuläret i ModalManager
if (window.modalManager) {
    window.modalManager.registerFormType('kickoff', {
        Vue: Vue,
        formComponent: formKickoff,
        store: store
    });
}

/**
 * Global function to create and mount a kickoff form app
 * Now uses ModalManager for centralized form handling
 * @param {string} selector - CSS selector for the target DOM element
 * @param {Object} props - Optional props to override element attributes
 * @returns {Vue|undefined} The mounted Vue instance, or undefined on error
 * @global
 */
window.createApp_kickoff = function(selector, props = {}) {
    if (!window.modalManager) {
        console.error('ModalManager not available for createApp_kickoff');
        return;
    }

    // Registrera kickoff-formuläret om det inte redan är registrerat
    if (!window.modalManager.isFormTypeRegistered('kickoff')) {
        window.modalManager.registerFormType('kickoff', {
            Vue: Vue,
            formComponent: formKickoff,
            store: store
        });
    }

    return window.modalManager.createFormApp('kickoff', selector, props);
};

/**
 * Automatically initializes all kickoff forms found in the DOM
 * Now uses ModalManager for centralized form handling
 * @returns {boolean} True if forms were found and processed, false if no forms exist
 */
let renderKickoffForms = function() {
    // Early exit if no forms exist on page
    const forms = document.querySelectorAll('.form-kickoff');
    if (forms.length === 0) {
        return false;
    }

    if (!window.modalManager) {
        console.error('ModalManager not available for renderKickoffForms');
        return false;
    }

    // Registrera kickoff-formuläret i ModalManager om det inte redan är registrerat
    if (!window.modalManager.isFormTypeRegistered || !window.modalManager.isFormTypeRegistered('kickoff')) {
        window.modalManager.registerFormType('kickoff', {
            Vue: Vue,
            formComponent: formKickoff,
            store: store
        });
    }

    forms.forEach((form, index) => {
        try {
            const parentBlock = form.closest('.nitea-form-selector');

            if (parentBlock) {
                // Inbäddade block initieras av form-selector/view.js (undvik dubbel mount)
                return;
            }


                // Footer/manual context: Force modal mode by setting display mode to modal
                if (!form.id) {

                    form.id = `form-kickoff-footer-${Date.now()}-${index}`;

                }

                window.modalManager.createFormApp('kickoff', `#${form.id}`, {
                    displayMode: 'modal'
                });
        } catch (error) {
            console.error(`Failed to initialize kickoff form ${index}:`, error);
        }
    });

    return true;
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderKickoffForms);
} else {
    renderKickoffForms();
}


/**
 * Expose renderKickoffForms globally for debugging and manual re-initialization
 * @global
 */
window.renderKickoffForms = renderKickoffForms;
